import React, { FC, useCallback } from "react";
import { INotification } from "../../utils";
import { NotificationSetting } from "./NotificationSetting";

interface NotificationSettingsProps {
  notifications: INotification[];
  editNotification: (notification: INotification) => void;
  deleteNotification: (minutes: number) => void;
}

export const NotificationSettings: FC<NotificationSettingsProps> = ({notifications , editNotification, deleteNotification}) => {
  const onDelete = useCallback((minutes: number) => (
    () => deleteNotification(minutes)
  ), [notifications])

  return (
  <>
    {notifications?.map((elem, i) => 
      <NotificationSetting 
        key={elem.minutes + i}
        notification={elem}
        onChange={editNotification}
        onDelete={onDelete(elem.minutes)}
      />
    )}
  </>
)};
